module.exports = __webpack_public_path__ + "img/table1-bg.ad009bb7.svg";